import { Label } from "reactstrap";
import TableComponent from "../../../components/TableComponent";
import { useSelector } from "react-redux";
import { HEALTH_MEMBER_DETAILS_HEADERS } from "./TableHeaders";

const HealthMemberDetails = (props: any) => {
    const {
        selectedApplication,
        storeMemberDetails
    } = useSelector((state: any) => state.grievances);

    const navigateToPrev = () => {
        props?.setShowCustomerTable(true);
        props?.setShowHealthMemberDetails(false);
    }


    return (
        <>
            <Label>
                <img 
                    src={require('../../../assets/img/Back.svg').default} 
                    style={{marginRight:'15px', cursor: 'pointer'}}
                    onClick={navigateToPrev}
                />
                <span>Policy Number: {selectedApplication?.policyNo || props?.getValues('searchHealthPolicy') || 'N/A'}</span>
            </Label>
            <TableComponent 
                data={storeMemberDetails}
                columnHeaders={HEALTH_MEMBER_DETAILS_HEADERS}
                onAction={props?.onTableAction}
                responsive={false}
            />
        </>
    );
}

export default HealthMemberDetails;